export default "__VITE_ASSET__CvsjG90f__"